// extracted by mini-css-extract-plugin
export default {"clearMargin":"styles_clearMargin__OL70R"};